import { Application } from "@hotwired/stimulus"
import SerpPreviewController from "./serp_preview_controller"
import AiMetadataController from "./ai_metadata_controller"
import MediaPickerController from "./media_picker_controller"
import AutosubmitController from "./autosubmit_controller"
import BulkSelectController from "./bulk_select_controller"
import CropperController from "./cropper_controller"
import DropzoneController from "./dropzone_controller"
import FolderModalController from "./folder_modal_controller"
import FolderSelectorController from "./folder_selector_controller"
import FolderTreeController from "./folder_tree_controller"
import MediaItemController from "./media_item_controller"

const application = Application.start()

// Register controllers
application.register("serp-preview", SerpPreviewController)
application.register("ai-metadata", AiMetadataController)
application.register("media-picker", MediaPickerController)
application.register("autosubmit", AutosubmitController)
application.register("bulk-select", BulkSelectController)
application.register("cropper", CropperController)
application.register("dropzone", DropzoneController)
application.register("folder-modal", FolderModalController)
application.register("folder-selector", FolderSelectorController)
application.register("folder-tree", FolderTreeController)
application.register("media-item", MediaItemController)

export { application }
